export const quotaLimitsPermission = {
    quotaLimitsCreate: "quota-limit.create",
    quotaLimitsUpdate: "quota-limit.update",
    quotaLimitsDelete: "quota-limit.delete",
    quotaLimitsView: "quota-limits.get"
};
